const { createSlice } = require("@reduxjs/toolkit");
const initialState = {
    expenses: [],
    expense: null,
    loading: false,
    error: null,
};

const expensesSlice = createSlice({
    name: "expenses",
    initialState,
    reducers: {
        setExpensesState: (state, { payload }) => {
            state.expenses = payload;
        },
        setExpenseState: (state, { payload }) => {
            state.expense = payload;
        },
        setLoading: (state, { payload }) => {
            state.loading = payload;
        },
        setError: (state, { payload }) => {
            state.error = payload;
        },
    },

});

export const { setExpensesState, setExpenseState, setLoading, setError } =
    expensesSlice.actions;

export default expensesSlice.reducer;
